"use client";

import { Capacitor } from "@capacitor/core";

export function isNativeApp() {
  try {
    return typeof window !== "undefined" && Capacitor.isNativePlatform();
  } catch {
    return false;
  }
}

export function isAndroidNativeApp() {
  try {
    return isNativeApp() && Capacitor.getPlatform() === "android";
  } catch {
    return false;
  }
}

export function isIOSNativeApp() {
  try {
    return isNativeApp() && Capacitor.getPlatform() === "ios";
  } catch {
    return false;
  }
}

export function getNativePlatform() {
  try {
    return isNativeApp() ? Capacitor.getPlatform() : "web";
  } catch {
    return "web";
  }
}
